"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('beach-umbrella', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M4.68148 18.8237C7.54032 8.15438 18.5071 1.82273 29.1764 4.68156C39.8457 7.5404 46.1774 18.5071 43.3185 29.1765L31.7274 26.0706L24 24.0001L16.2726 21.9295L4.68148 18.8237Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M29.1764 4.68156C18.5071 1.82273 7.54032 8.15438 4.68148 18.8237L16.2726 21.9295M29.1764 4.68156C39.8457 7.5404 46.1774 18.5071 43.3185 29.1765L31.7274 26.0706M29.1764 4.68156C29.1764 4.68156 32.229 10.6759 32.8667 16.0231C33.5045 21.3704 31.7274 26.0706 31.7274 26.0706M29.1764 4.68156C29.1764 4.68156 23.5356 8.34651 20.3097 12.6585C17.0837 16.9705 16.2726 21.9295 16.2726 21.9295M24 24.0001L18.5 44M24 24.0001L16.2726 21.9295M24 24.0001L31.7274 26.0706M4 44.0001H44",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;